<div class="contenedor" [ngClass]="{ 'warning-selector': warningSelector }">
  <ion-button
    [attr.data-test]="'Automation.btn-card-decrease' | translate"
    [mode]="configurations.mode"
    [size]="configurations.size"
    [disabled]="initial === configurations.initial"
    class="ion-no-margin button-remove"
    (click)="onRemove()"
  >
    <ion-icon
      [name]="configurations.iconRemove.name"
      slot="icon-only"
      [size]="configurations.iconRemove.size"
      [color]="configurations.iconRemove.color"
    ></ion-icon>
  </ion-button>

  <!-- <span class="binding">{{ initial }}</span> -->

  <ion-input
    [attr.data-test]="'Automation.txtbox-card-input' | translate"
    class="ion-no-margin ion-text-center"
    [(ngModel)]="initial"
    (ionChange)="validated(initial)"
    type="tel"
    inputmode="numeric"
    mode="ios"
    id="range"
    maxlength="3"
    minlength="1"
    min="1"
    max="20"
    pattern="^[0-9]\d*$"
    readonly
    required
  ></ion-input>

  <ion-button
    [attr.data-test]="'Automation.btn-card-increase' | translate"
    [mode]="configurations.mode"
    [size]="configurations.size"
    class="ion-no-margin"
    [disabled]="initial === configurations.end"
    style="--border-radius: 0 3px 3px 0"
    (click)="onAdd()"
  >
    <ion-icon
      [name]="configurations.iconAdd.name"
      slot="icon-only"
      [size]="configurations.iconAdd.size"
      [color]="configurations.iconAdd.color"
    ></ion-icon>
  </ion-button>
</div>
